<template>
	<div id="app" class="pa-container" :class="{ isAdmin }">
		<router-view></router-view>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import axios from "axios";

export default {
	name: "app",
	props: {
		is_admin: {
			type: Boolean,
			default: false,
		},
		is_dev: {
			type: Boolean,
			default: false,
		},
		create: {
			type: Boolean,
			default: false,
		},
	},
	created() {
		this.$store.commit("setIsAdmin", this.is_admin);
		this.$store.commit("setIsDev", this.is_dev);
	},
	components: {},
	data: function () {
		return {};
	},
	mounted() {
		this.initSettings();
		if (this.create) {
			this.$store.commit("initClassified");
		} else {
			this.loadClassified();
		}
	},
	methods: {
		...mapMutations(["initClassified"]), // "setStep",
		initSettings() {
			axios
				.post(
					this.config.app.gateway + "?action=classified_v2_settings",
					{
						action: "classified_v2_settings",
					},
					{
						headers: {
							"Content-Type": "application/json",
						},
					}
				)
				.then((response) => {
					if (!response.error) {
						this.$store.commit("setSettings", response.data);
					}
				})
				.catch((response) => {
					//
				});
		},
		loadClassified() {
			if (this.$route.query.preset) {
				this.$cookie.delete("pa-uniq_id");
				// this.$store.commit("SET_PRESET", JSON.parse(this.$route.query.preset));
				this.$store.commit(
					"SET_CLASSIFIED",
					JSON.parse(this.$route.query.preset)
				);
			}
			let uniqid = null;
			if (this.$route.query.uniqid) {
				uniqid = this.$route.query.uniqid;
			} else {
				if (this.$cookie.get("pa-uniq_id")) {
					uniqid = this.$cookie.get("pa-uniq_id");
				}
			}
			if (uniqid) {
				axios
					.post(
						this.config.app.gateway + "?action=classified_v2_load",
						{
							action: "classified_v2_load",
							uniq_id: uniqid,
						},
						{
							headers: {
								"Content-Type": "application/json",
							},
						}
					)
					.then((response) => {
						if (!response.error) {
							this.$store.commit("SET_CLASSIFIED", response.data);
							// this.$store.commit("setStep", "1");
							if (!this.$store.state.is_admin) {
								this.$router.push({
									path: this.config.app.url,
									query: this.$route.query,
								});
							}
						}
					})
					.catch((response) => {
						//
					});
			}
		},
	},
	computed: {
		...mapGetters(["classified", "isAdmin"]),
		settings() {
			return this.$store.state.settings;
		},
		categories() {
			return this.$store.state.categories;
		},
	},
};
</script>

<style lang="scss">
.selector {
	.required,
	.maxLength {
		display: none;
		color: #d22e26;
	}

	&.missing {
		.required {
			display: block;
		}
	}

	&.contentTooLong {
		.maxLength {
			display: block;
		}
	}
}
</style>
